<section class="login d-flex py-5">
  @if (this.image !== undefined) {
  <figure class="position-absolute top-0 start-0 w-100 h-100 z-0 m-0 overflow-hidden">
    <img
      [src]="image?.url"
      [alt]="image?.copyright"
      class="object-fit-cover"
      style="filter: blur(5px) brightness(0.5); width: calc(100% + 20px); height: calc(100% + 20px); margin-top: -10px; margin-left: -10px"
    />
  </figure>
  }
  <div class="container position-relative d-flex flex-column align-items-center gap-5">
    <h1 class="display-1 fw-light text-light mb-0 fs-4">{{ date }}</h1>

    <form [formGroup]="form" class="m-auto" (keydown.enter)="login()" autocomplete="off">
      <main>
        <div class="text-light mx-auto mb-5" style="width: 70px">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" class="bi bi-person-circle">
            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"></path>
            <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"></path>
          </svg>
        </div>

        <div class="d-flex flex-column gap-2">
          <div class="d-flex flex-column bg-transparent p-1 rounded-pill">
            <input
              placeholder="Correo electrónico"
              type="text"
              pInputText
              class="h-50px bg-transparent rounded-pill px-4 text-light"
              [disabled]="true"
              [value]="this.user?.email"
              style="text-shadow: 0px 1px 2px #787878"
            />
          </div>
          <div class="d-flex bg-light p-1 rounded-pill">
            <div class="w-100">
              <p-password
                formControlName="password"
                placeholder="Contraseña"
                [feedback]="false"
                [toggleMask]="true"
                styleClass="w-100 h-50px"
                [inputStyleClass]="
                  inputPassword?.invalid && (inputPassword?.dirty || inputPassword?.touched) && inputPassword?.errors
                    ? 'w-100 h-50px bg-light border-danger rounded-0 rounded-pill ps-4'
                    : 'w-100 h-50px bg-light rounded-0 rounded-pill ps-4'
                "
              />
            </div>
            <div class="bg-light d-flex flex-column justify-content-center align-items-center px-2 rounded-end-pill">
              <p-button icon="bi bi-key" [rounded]="true" [loading]="isLoading" (onClick)="login()" [disabled]="!form.valid" />
            </div>
          </div>
        </div>
      </main>
    </form>

    <div class="d-flex flex-column">
      <div class="text-center mb-3">
        <p-button icon="pi pi-power-off" [rounded]="true" (onClick)="clearSession()" severity="primary" />
      </div>
    </div>
  </div>
</section>
